import React, { useState, useEffect, useCallback } from 'react';

const COOKIE_NAME = 'chatlab_consent';
const COOKIE_DAYS = 365;
export const CONSENTED_CLASS = 'cl-consented';
const SUPPORTED_LANGS = [
  'pl', 'de', 'es', 'fr', 'it', 'tr', 'hu', 'ro', 'cs', 'sk',
  'nl', 'pt', 'sv', 'da', 'no', 'fi', 'el', 'uk', 'ru', 'bg', 'sr', 'lt', 'lv', 'et',
];

const TRANSLATIONS = {
  en: {
    banner_title: 'This website uses cookies',
    banner_message: 'We use cookies to personalise content and ads, to provide social media features and to analyse our traffic. We also share information about your use of our site with advertising and analytics partners who may combine it with other information that you\'ve provided to them or that they\'ve collected from your use of their services.',
    customize: 'Customize',
    accept_all: 'Accept All',
    deny_all: 'Deny All',
    save: 'Save Preferences',
    title: 'Cookie Preferences',
    necessary: 'Necessary',
    necessary_desc: 'Essential for the website to function properly.',
    statistics: 'Statistics',
    statistics_desc: 'Help us understand how visitors interact with our website.',
    marketing: 'Marketing',
    marketing_desc: 'Used to deliver relevant ads and measure campaign effectiveness.',
    preferences: 'Preferences',
    preferences_desc: 'Remember your settings and personalization choices.',
    always_on: 'Always on',
    read_more: 'Read more',
  },
  pl: {
    banner_title: 'Ta strona używa plików cookie',
    banner_message: 'Używamy plików cookie do personalizacji treści i reklam, udostępniania funkcji mediów społecznościowych oraz analizy ruchu. Udostępniamy również informacje o korzystaniu z naszej strony partnerom reklamowym i analitycznym, którzy mogą je łączyć z innymi informacjami, które im przekazałeś lub które zebrali w związku z korzystaniem przez Ciebie z ich usług.',
    customize: 'Dostosuj',
    accept_all: 'Akceptuj wszystkie',
    deny_all: 'Odrzuć wszystkie',
    save: 'Zapisz preferencje',
    title: 'Preferencje plików cookie',
    necessary: 'Niezbędne',
    necessary_desc: 'Niezbędne do prawidłowego działania strony.',
    statistics: 'Statystyczne',
    statistics_desc: 'Pomagają zrozumieć, jak odwiedzający korzystają ze strony.',
    marketing: 'Marketingowe',
    marketing_desc: 'Służą do wyświetlania trafnych reklam i mierzenia skuteczności kampanii.',
    preferences: 'Preferencje',
    preferences_desc: 'Zapamiętują ustawienia i personalizację.',
    always_on: 'Zawsze włączone',
    read_more: 'Czytaj więcej',
  },
  de: {
    banner_title: 'Diese Website verwendet Cookies',
    banner_message: 'Wir verwenden Cookies, um Inhalte und Anzeigen zu personalisieren, Funktionen für soziale Medien bereitzustellen und unseren Datenverkehr zu analysieren. Wir teilen auch Informationen über Ihre Nutzung unserer Website mit unseren Werbe- und Analysepartnern, die diese mit anderen Informationen kombinieren können, die Sie ihnen bereitgestellt haben oder die sie im Rahmen Ihrer Nutzung ihrer Dienste gesammelt haben.',
    customize: 'Anpassen',
    accept_all: 'Alle akzeptieren',
    deny_all: 'Alle ablehnen',
    save: 'Einstellungen speichern',
    title: 'Cookie-Einstellungen',
    necessary: 'Notwendig',
    necessary_desc: 'Essentiell für die ordnungsgemäße Funktion der Website.',
    statistics: 'Statistik',
    statistics_desc: 'Helfen uns zu verstehen, wie Besucher mit unserer Website interagieren.',
    marketing: 'Marketing',
    marketing_desc: 'Werden verwendet, um relevante Anzeigen zu schalten und die Kampagneneffektivität zu messen.',
    preferences: 'Präferenzen',
    preferences_desc: 'Merken sich Ihre Einstellungen und Personalisierungen.',
    always_on: 'Immer aktiv',
    read_more: 'Mehr erfahren',
  },
  es: {
    banner_title: 'Este sitio web utiliza cookies',
    banner_message: 'Utilizamos cookies para personalizar el contenido y los anuncios, ofrecer funciones de redes sociales y analizar nuestro tráfico. También compartimos información sobre el uso que haces de nuestro sitio con nuestros partners de publicidad y analítica, quienes pueden combinarla con otra información que les hayas proporcionado o que hayan recopilado a partir del uso que hayas hecho de sus servicios.',
    customize: 'Personalizar',
    accept_all: 'Aceptar todas',
    deny_all: 'Rechazar todas',
    save: 'Guardar preferencias',
    title: 'Preferencias de cookies',
    necessary: 'Necesarias',
    necessary_desc: 'Imprescindibles para que el sitio web funcione correctamente.',
    statistics: 'Estadísticas',
    statistics_desc: 'Nos ayudan a entender cómo interactúan los visitantes con nuestro sitio web.',
    marketing: 'Marketing',
    marketing_desc: 'Se utilizan para ofrecer anuncios relevantes y medir la eficacia de las campañas.',
    preferences: 'Preferencias',
    preferences_desc: 'Recuerdan tus ajustes y opciones de personalización.',
    always_on: 'Siempre activas',
    read_more: 'Más información',
  },
  fr: {
    banner_title: 'Ce site utilise des cookies',
    banner_message: 'Nous utilisons des cookies pour personnaliser le contenu et les annonces, offrir des fonctionnalités relatives aux médias sociaux et analyser notre trafic. Nous partageons également des informations sur l\'utilisation de notre site avec nos partenaires de publicité et d\'analyse, qui peuvent combiner celles-ci avec d\'autres informations que vous leur avez fournies ou qu\'ils ont collectées lors de votre utilisation de leurs services.',
    customize: 'Personnaliser',
    accept_all: 'Tout accepter',
    deny_all: 'Tout refuser',
    save: 'Enregistrer les préférences',
    title: 'Préférences de cookies',
    necessary: 'Nécessaires',
    necessary_desc: 'Indispensables au bon fonctionnement du site web.',
    statistics: 'Statistiques',
    statistics_desc: 'Nous aident à comprendre comment les visiteurs interagissent avec notre site web.',
    marketing: 'Marketing',
    marketing_desc: 'Utilisés pour diffuser des annonces pertinentes et mesurer l\'efficacité des campagnes.',
    preferences: 'Préférences',
    preferences_desc: 'Mémorisent vos paramètres et vos choix de personnalisation.',
    always_on: 'Toujours activé',
    read_more: 'En savoir plus',
  },
  it: {
    banner_title: 'Questo sito web utilizza i cookie',
    banner_message: 'Utilizziamo i cookie per personalizzare contenuti e annunci, fornire funzionalità per i social media e analizzare il nostro traffico. Condividiamo inoltre informazioni sul modo in cui utilizzi il nostro sito con i nostri partner di pubblicità e analisi, che potrebbero combinarle con altre informazioni che hai fornito loro o che hanno raccolto dall\'utilizzo dei loro servizi.',
    customize: 'Personalizza',
    accept_all: 'Accetta tutti',
    deny_all: 'Rifiuta tutti',
    save: 'Salva preferenze',
    title: 'Preferenze cookie',
    necessary: 'Necessari',
    necessary_desc: 'Essenziali per il corretto funzionamento del sito web.',
    statistics: 'Statistici',
    statistics_desc: 'Ci aiutano a capire come i visitatori interagiscono con il nostro sito web.',
    marketing: 'Marketing',
    marketing_desc: 'Utilizzati per offrire annunci pertinenti e misurare l\'efficacia delle campagne.',
    preferences: 'Preferenze',
    preferences_desc: 'Memorizzano le tue impostazioni e le scelte di personalizzazione.',
    always_on: 'Sempre attivi',
    read_more: 'Leggi di più',
  },
  tr: {
    banner_title: 'Bu web sitesi çerezleri kullanır',
    banner_message: 'İçeriği ve reklamları kişiselleştirmek, sosyal medya özellikleri sağlamak ve trafiğimizi analiz etmek için çerezler kullanıyoruz. Ayrıca sitemizi kullanımınızla ilgili bilgileri, kendilerine sağladığınız veya hizmetlerini kullanımınızdan topladıkları diğer bilgilerle birleştirebilecek reklam ve analiz ortaklarımızla paylaşıyoruz.',
    customize: 'Özelleştir',
    accept_all: 'Tümünü kabul et',
    deny_all: 'Tümünü reddet',
    save: 'Tercihleri kaydet',
    title: 'Çerez tercihleri',
    necessary: 'Gerekli',
    necessary_desc: 'Web sitesinin düzgün çalışması için zorunludur.',
    statistics: 'İstatistik',
    statistics_desc: 'Ziyaretçilerin web sitemizle nasıl etkileşime girdiğini anlamamıza yardımcı olur.',
    marketing: 'Pazarlama',
    marketing_desc: 'İlgili reklamları sunmak ve kampanya etkinliğini ölçmek için kullanılır.',
    preferences: 'Tercihler',
    preferences_desc: 'Ayarlarınızı ve kişiselleştirme seçimlerinizi hatırlar.',
    always_on: 'Her zaman etkin',
    read_more: 'Daha fazla bilgi',
  },
  hu: {
    banner_title: 'Ez a webhely sütiket használ',
    banner_message: 'Sütiket használunk a tartalom és a hirdetések személyre szabásához, közösségi média funkciók biztosításához és a forgalmunk elemzéséhez. A webhelyünk használatáról szóló információkat megosztjuk hirdetési és analitikai partnereinkkel is, akik ezeket összekapcsolhatják más adatokkal, amelyeket Ön adott meg nekik, vagy amelyeket az Ön szolgáltatáshasználatából gyűjtöttek.',
    customize: 'Testreszabás',
    accept_all: 'Összes elfogadása',
    deny_all: 'Összes elutasítása',
    save: 'Beállítások mentése',
    title: 'Sütibeállítások',
    necessary: 'Szükséges',
    necessary_desc: 'Elengedhetetlen a webhely megfelelő működéséhez.',
    statistics: 'Statisztika',
    statistics_desc: 'Segít megértenünk, hogyan lépnek kapcsolatba a látogatók a webhelyünkkel.',
    marketing: 'Marketing',
    marketing_desc: 'Releváns hirdetések megjelenítésére és a kampányok hatékonyságának mérésére szolgál.',
    preferences: 'Preferenciák',
    preferences_desc: 'Megjegyzi az Ön beállításait és személyre szabási döntéseit.',
    always_on: 'Mindig aktív',
    read_more: 'További információ',
  },
  ro: {
    banner_title: 'Acest site web utilizează cookie-uri',
    banner_message: 'Utilizăm cookie-uri pentru a personaliza conținutul și anunțurile, pentru a oferi funcții de rețele sociale și pentru a analiza traficul. De asemenea, partajăm informații despre modul în care utilizați site-ul nostru cu partenerii noștri de publicitate și de analiză, care le pot combina cu alte informații pe care li le-ați furnizat sau pe care le-au colectat din utilizarea serviciilor lor.',
    customize: 'Personalizați',
    accept_all: 'Acceptați toate',
    deny_all: 'Respingeți toate',
    save: 'Salvați preferințele',
    title: 'Preferințe privind cookie-urile',
    necessary: 'Necesare',
    necessary_desc: 'Esențiale pentru funcționarea corectă a site-ului web.',
    statistics: 'Statistici',
    statistics_desc: 'Ne ajută să înțelegem cum interacționează vizitatorii cu site-ul nostru.',
    marketing: 'Marketing',
    marketing_desc: 'Utilizate pentru a afișa anunțuri relevante și pentru a măsura eficiența campaniilor.',
    preferences: 'Preferințe',
    preferences_desc: 'Rețin setările și opțiunile dumneavoastră de personalizare.',
    always_on: 'Întotdeauna active',
    read_more: 'Aflați mai multe',
  },
  cs: {
    banner_title: 'Tento web používá soubory cookie',
    banner_message: 'Soubory cookie používáme k personalizaci obsahu a reklam, k poskytování funkcí sociálních sítí a k analýze návštěvnosti. Informace o tom, jak náš web používáte, sdílíme také s našimi reklamními a analytickými partnery, kteří je mohou zkombinovat s dalšími údaji, které jste jim poskytli nebo které získali na základě vašeho používání jejich služeb.',
    customize: 'Přizpůsobit',
    accept_all: 'Přijmout vše',
    deny_all: 'Odmítnout vše',
    save: 'Uložit předvolby',
    title: 'Předvolby souborů cookie',
    necessary: 'Nezbytné',
    necessary_desc: 'Nezbytné pro správné fungování webu.',
    statistics: 'Statistické',
    statistics_desc: 'Pomáhají nám pochopit, jak návštěvníci s naším webem pracují.',
    marketing: 'Marketingové',
    marketing_desc: 'Slouží k zobrazování relevantních reklam a k měření účinnosti kampaní.',
    preferences: 'Předvolby',
    preferences_desc: 'Zapamatují si vaše nastavení a volby personalizace.',
    always_on: 'Vždy aktivní',
    read_more: 'Zjistit více',
  },
  sk: {
    banner_title: 'Táto webová stránka používa súbory cookie',
    banner_message: 'Súbory cookie používame na personalizáciu obsahu a reklám, na poskytovanie funkcií sociálnych sietí a na analýzu návštevnosti. Informácie o tom, ako našu stránku používate, zdieľame aj s našimi reklamnými a analytickými partnermi, ktorí ich môžu skombinovať s ďalšími údajmi, ktoré ste im poskytli alebo ktoré získali z vášho používania ich služieb.',
    customize: 'Prispôsobiť',
    accept_all: 'Prijať všetko',
    deny_all: 'Odmietnuť všetko',
    save: 'Uložiť predvoľby',
    title: 'Predvoľby súborov cookie',
    necessary: 'Nevyhnutné',
    necessary_desc: 'Nevyhnutné pre správne fungovanie stránky.',
    statistics: 'Štatistické',
    statistics_desc: 'Pomáhajú nám pochopiť, ako návštevníci našu stránku používajú.',
    marketing: 'Marketingové',
    marketing_desc: 'Slúžia na zobrazovanie relevantných reklám a na meranie účinnosti kampaní.',
    preferences: 'Predvoľby',
    preferences_desc: 'Zapamätajú si vaše nastavenia a voľby personalizácie.',
    always_on: 'Vždy aktívne',
    read_more: 'Zistiť viac',
  },
  nl: {
    banner_title: 'Deze website gebruikt cookies',
    banner_message: 'We gebruiken cookies om content en advertenties te personaliseren, functies voor sociale media te bieden en ons verkeer te analyseren. We delen ook informatie over jouw gebruik van onze website met onze advertentie- en analysepartners, die deze kunnen combineren met andere gegevens die je aan hen hebt verstrekt of die zij hebben verzameld via jouw gebruik van hun diensten.',
    customize: 'Aanpassen',
    accept_all: 'Alles accepteren',
    deny_all: 'Alles weigeren',
    save: 'Voorkeuren opslaan',
    title: 'Cookievoorkeuren',
    necessary: 'Noodzakelijk',
    necessary_desc: 'Essentieel voor de goede werking van de website.',
    statistics: 'Statistieken',
    statistics_desc: 'Helpen ons begrijpen hoe bezoekers onze website gebruiken.',
    marketing: 'Marketing',
    marketing_desc: 'Worden gebruikt om relevante advertenties te tonen en campagneresultaten te meten.',
    preferences: 'Voorkeuren',
    preferences_desc: 'Onthouden jouw instellingen en keuzes voor personalisatie.',
    always_on: 'Altijd actief',
    read_more: 'Lees meer',
  },
  pt: {
    banner_title: 'Este website utiliza cookies',
    banner_message: 'Utilizamos cookies para personalizar conteúdos e anúncios, fornecer funcionalidades de redes sociais e analisar o nosso tráfego. Também partilhamos informações sobre a sua utilização do nosso site com os nossos parceiros de publicidade e de análise, que as podem combinar com outras informações fornecidas ou recolhidas a partir da utilização dos seus serviços.',
    customize: 'Personalizar',
    accept_all: 'Aceitar todos',
    deny_all: 'Rejeitar todos',
    save: 'Guardar preferências',
    title: 'Preferências de cookies',
    necessary: 'Necessários',
    necessary_desc: 'Essenciais para o funcionamento correto do website.',
    statistics: 'Estatísticas',
    statistics_desc: 'Ajudam a compreender como os visitantes interagem com o nosso website.',
    marketing: 'Marketing',
    marketing_desc: 'Utilizados para apresentar anúncios relevantes e medir a eficácia das campanhas.',
    preferences: 'Preferências',
    preferences_desc: 'Guardam as suas definições e opções de personalização.',
    always_on: 'Sempre ativos',
    read_more: 'Saber mais',
  },
  sv: {
    banner_title: 'Den här webbplatsen använder cookies',
    banner_message: 'Vi använder cookies för att anpassa innehåll och annonser, tillhandahålla funktioner för sociala medier och analysera vår trafik. Vi delar även information om din användning av webbplatsen med våra annons- och analyspartner, som kan kombinera den med annan information som du har gett dem eller som de har samlat in när du har använt deras tjänster.',
    customize: 'Anpassa',
    accept_all: 'Godkänn alla',
    deny_all: 'Neka alla',
    save: 'Spara inställningar',
    title: 'Cookieinställningar',
    necessary: 'Nödvändiga',
    necessary_desc: 'Nödvändiga för att webbplatsen ska fungera som den ska.',
    statistics: 'Statistik',
    statistics_desc: 'Hjälper oss att förstå hur besökare använder webbplatsen.',
    marketing: 'Marknadsföring',
    marketing_desc: 'Används för att visa relevanta annonser och mäta kampanjers effektivitet.',
    preferences: 'Inställningar',
    preferences_desc: 'Kommer ihåg dina val och anpassningar.',
    always_on: 'Alltid aktiva',
    read_more: 'Läs mer',
  },
  da: {
    banner_title: 'Denne hjemmeside bruger cookies',
    banner_message: 'Vi bruger cookies til at tilpasse indhold og annoncer, levere funktioner til sociale medier og analysere vores trafik. Vi deler også oplysninger om din brug af vores website med vores partnere inden for annoncering og analyse, som kan kombinere dem med andre oplysninger, du har givet dem, eller som de har indsamlet fra din brug af deres tjenester.',
    customize: 'Tilpas',
    accept_all: 'Acceptér alle',
    deny_all: 'Afvis alle',
    save: 'Gem præferencer',
    title: 'Cookiepræferencer',
    necessary: 'Nødvendige',
    necessary_desc: 'Vigtige for, at hjemmesiden fungerer korrekt.',
    statistics: 'Statistik',
    statistics_desc: 'Hjælper os med at forstå, hvordan besøgende bruger vores hjemmeside.',
    marketing: 'Markedsføring',
    marketing_desc: 'Bruges til at vise relevante annoncer og måle kampagnens effektivitet.',
    preferences: 'Præferencer',
    preferences_desc: 'Husker dine indstillinger og valg for personlig tilpasning.',
    always_on: 'Altid aktiv',
    read_more: 'Læs mere',
  },
  no: {
    banner_title: 'Dette nettstedet bruker informasjonskapsler',
    banner_message: 'Vi bruker informasjonskapsler for å tilpasse innhold og annonser, tilby funksjoner for sosiale medier og analysere trafikken vår. Vi deler også informasjon om hvordan du bruker nettstedet vårt, med partnerne våre innen annonsering og analyse, som kan kombinere den med annen informasjon du har gitt dem, eller som de har samlet inn fra din bruk av tjenestene deres.',
    customize: 'Tilpass',
    accept_all: 'Godta alle',
    deny_all: 'Avvis alle',
    save: 'Lagre innstillinger',
    title: 'Innstillinger for informasjonskapsler',
    necessary: 'Nødvendige',
    necessary_desc: 'Helt nødvendige for at nettstedet skal fungere som det skal.',
    statistics: 'Statistikk',
    statistics_desc: 'Hjelper oss med å forstå hvordan besøkende bruker nettstedet vårt.',
    marketing: 'Markedsføring',
    marketing_desc: 'Brukes til å vise relevante annonser og måle effekten av kampanjer.',
    preferences: 'Preferanser',
    preferences_desc: 'Husker innstillingene og de personlige valgene dine.',
    always_on: 'Alltid på',
    read_more: 'Les mer',
  },
  fi: {
    banner_title: 'Tämä sivusto käyttää evästeitä',
    banner_message: 'Käytämme evästeitä sisällön ja mainosten mukauttamiseen, sosiaalisen median ominaisuuksien tarjoamiseen sekä liikenteen analysointiin. Jaamme myös tietoja sivuston käytöstäsi mainos- ja analytiikkakumppaneillemme, jotka saattavat yhdistää niitä muihin tietoihin, joita olet heille antanut tai joita he ovat keränneet palveluidensa käytöstä.',
    customize: 'Mukauta',
    accept_all: 'Hyväksy kaikki',
    deny_all: 'Hylkää kaikki',
    save: 'Tallenna valinnat',
    title: 'Evästeasetukset',
    necessary: 'Välttämättömät',
    necessary_desc: 'Olennaisia verkkosivuston moitteettoman toiminnan kannalta.',
    statistics: 'Tilastot',
    statistics_desc: 'Auttavat ymmärtämään, miten kävijät käyttävät sivustoamme.',
    marketing: 'Markkinointi',
    marketing_desc: 'Käytetään osuvien mainosten näyttämiseen ja kampanjoiden tehokkuuden mittaamiseen.',
    preferences: 'Asetukset',
    preferences_desc: 'Muistavat valitsemasi asetukset ja mukautukset.',
    always_on: 'Aina käytössä',
    read_more: 'Lue lisää',
  },
  el: {
    banner_title: 'Αυτός ο ιστότοπος χρησιμοποιεί cookies',
    banner_message: 'Χρησιμοποιούμε cookies για την εξατομίκευση περιεχομένου και διαφημίσεων, την παροχή λειτουργιών κοινωνικών μέσων και την ανάλυση της επισκεψιμότητάς μας. Επίσης, μοιραζόμαστε πληροφορίες σχετικά με τη χρήση του ιστοτόπου μας με συνεργάτες διαφήμισης και ανάλυσης, οι οποίοι ενδέχεται να τις συνδυάσουν με άλλες πληροφορίες που τους έχετε παραχωρήσει ή που έχουν συλλέξει από τη χρήση των υπηρεσιών τους από εσάς.',
    customize: 'Προσαρμογή',
    accept_all: 'Αποδοχή όλων',
    deny_all: 'Απόρριψη όλων',
    save: 'Αποθήκευση προτιμήσεων',
    title: 'Προτιμήσεις cookies',
    necessary: 'Απαραίτητα',
    necessary_desc: 'Απαραίτητα για τη σωστή λειτουργία του ιστοτόπου.',
    statistics: 'Στατιστικά',
    statistics_desc: 'Μας βοηθούν να κατανοήσουμε πώς αλληλεπιδρούν οι επισκέπτες με τον ιστότοπό μας.',
    marketing: 'Μάρκετινγκ',
    marketing_desc: 'Χρησιμοποιούνται για την προβολή σχετικών διαφημίσεων και τη μέτρηση της αποτελεσματικότητας των καμπανιών.',
    preferences: 'Προτιμήσεις',
    preferences_desc: 'Απομνημονεύουν τις ρυθμίσεις σας και τις επιλογές εξατομίκευσης.',
    always_on: 'Πάντα ενεργά',
    read_more: 'Διαβάστε περισσότερα',
  },
  uk: {
    banner_title: 'Цей сайт використовує файли cookie',
    banner_message: 'Ми використовуємо файли cookie для персоналізації вмісту та реклами, надання функцій соціальних мереж і аналізу нашого трафіку. Ми також ділимося інформацією про використання вами нашого сайту з нашими партнерами з реклами та аналітики, які можуть поєднувати її з іншими даними, які ви їм надали або які вони зібрали під час використання вами їхніх послуг.',
    customize: 'Налаштувати',
    accept_all: 'Прийняти всі',
    deny_all: 'Відхилити всі',
    save: 'Зберегти налаштування',
    title: 'Налаштування файлів cookie',
    necessary: 'Необхідні',
    necessary_desc: 'Важливі для належної роботи сайту.',
    statistics: 'Статистика',
    statistics_desc: 'Допомагають нам зрозуміти, як відвідувачі взаємодіють із сайтом.',
    marketing: 'Маркетинг',
    marketing_desc: 'Використовуються для показу релевантної реклами та оцінки ефективності кампаній.',
    preferences: 'Вподобання',
    preferences_desc: 'Запам\'ятовують ваші налаштування та вибір персоналізації.',
    always_on: 'Завжди активні',
    read_more: 'Детальніше',
  },
  ru: {
    banner_title: 'Этот сайт использует файлы cookie',
    banner_message: 'Мы используем файлы cookie для персонализации контента и рекламы, предоставления функций социальных сетей и анализа нашего трафика. Мы также передаем информацию об использовании вами нашего сайта партнерам по рекламе и аналитике, которые могут объединять ее с другими данными, предоставленными вами или собранными в процессе использования их сервисов.',
    customize: 'Настроить',
    accept_all: 'Принять все',
    deny_all: 'Отклонить все',
    save: 'Сохранить настройки',
    title: 'Настройки cookie',
    necessary: 'Необходимые',
    necessary_desc: 'Необходимы для правильной работы сайта.',
    statistics: 'Статистика',
    statistics_desc: 'Помогают нам понять, как посетители взаимодействуют с сайтом.',
    marketing: 'Маркетинг',
    marketing_desc: 'Используются для показа релевантной рекламы и оценки эффективности кампаний.',
    preferences: 'Настройки',
    preferences_desc: 'Запоминают ваши настройки и параметры персонализации.',
    always_on: 'Всегда включены',
    read_more: 'Подробнее',
  },
  bg: {
    banner_title: 'Този уебсайт използва бисквитки',
    banner_message: 'Използваме бисквитки за персонализиране на съдържанието и рекламите, за предоставяне на функции за социални медии и за анализ на трафика. Също така споделяме информация за начина, по който използвате сайта ни, с партньорите си за реклама и анализ, които могат да я комбинират с друга информация, предоставена от Вас или събрана при използването на техните услуги.',
    customize: 'Персонализиране',
    accept_all: 'Приемане на всички',
    deny_all: 'Отказване на всички',
    save: 'Запазване на предпочитанията',
    title: 'Предпочитания за бисквитки',
    necessary: 'Необходими',
    necessary_desc: 'Задължителни за правилното функциониране на уебсайта.',
    statistics: 'Статистика',
    statistics_desc: 'Помагат ни да разберем как посетителите взаимодействат с уебсайта.',
    marketing: 'Маркетинг',
    marketing_desc: 'Използват се за показване на подходящи реклами и измерване на ефективността на кампаниите.',
    preferences: 'Предпочитания',
    preferences_desc: 'Запомнят Вашите настройки и избори за персонализация.',
    always_on: 'Винаги активни',
    read_more: 'Научете повече',
  },
  sr: {
    banner_title: 'Ovaj veb-sajt koristi kolačiće',
    banner_message: 'Koristimo kolačiće za prilagođavanje sadržaja i oglasa, pružanje funkcija društvenih medija i analizu našeg saobraćaja. Takođe delimo informacije o tome kako koristite naš sajt sa partnerima za oglašavanje i analitiku, koji ih mogu kombinovati sa drugim informacijama koje ste im pružili ili koje su prikupili tokom vašeg korišćenja njihovih usluga.',
    customize: 'Prilagodite',
    accept_all: 'Prihvati sve',
    deny_all: 'Odbij sve',
    save: 'Sačuvaj podešavanja',
    title: 'Podešavanja kolačića',
    necessary: 'Neophodni',
    necessary_desc: 'Neophodni za pravilno funkcionisanje veb-sajta.',
    statistics: 'Statistika',
    statistics_desc: 'Pomažu nam da razumemo kako posetioci koriste naš veb-sajt.',
    marketing: 'Marketing',
    marketing_desc: 'Koriste se za prikazivanje relevantnih oglasa i merenje uspešnosti kampanja.',
    preferences: 'Podešavanja',
    preferences_desc: 'Pamte Vaša podešavanja i izbore personalizacije.',
    always_on: 'Uvek aktivno',
    read_more: 'Saznajte više',
  },
  lt: {
    banner_title: 'Šioje svetainėje naudojami slapukai',
    banner_message: 'Naudojame slapukus turiniui ir reklamoms pritaikyti, socialinių tinklų funkcijoms teikti bei srautui analizuoti. Informacija apie tai, kaip naudojatės mūsų svetaine, taip pat dalijamės su reklamos ir analitikos partneriais, kurie gali ją sujungti su kita informacija, kurią jiems pateikėte arba kurią jie surinko jums naudojantis jų paslaugomis.',
    customize: 'Tinkinti',
    accept_all: 'Priimti visus',
    deny_all: 'Atmesti visus',
    save: 'Išsaugoti pasirinkimus',
    title: 'Slapukų nustatymai',
    necessary: 'Būtinieji',
    necessary_desc: 'Būtini, kad svetainė veiktų tinkamai.',
    statistics: 'Statistika',
    statistics_desc: 'Padeda suprasti, kaip lankytojai naudojasi svetaine.',
    marketing: 'Rinkodara',
    marketing_desc: 'Naudojami aktualioms reklamoms rodyti ir kampanijų efektyvumui vertinti.',
    preferences: 'Nuostatos',
    preferences_desc: 'Įsimena jūsų pasirinktus nustatymus ir pritaikymą.',
    always_on: 'Visada aktyvūs',
    read_more: 'Skaityti daugiau',
  },
  lv: {
    banner_title: 'Šī vietne izmanto sīkfailus',
    banner_message: 'Mēs izmantojam sīkfailus, lai personalizētu saturu un reklāmas, nodrošinātu sociālo mediju funkcijas un analizētu mūsu datplūsmu. Informāciju par to, kā izmantojat mūsu vietni, mēs kopīgojam arī ar reklāmas un analītikas partneriem, kuri var to apvienot ar citu informāciju, ko esat viņiem snieguši vai ko viņi ir apkopojuši, kad izmantojat viņu pakalpojumus.',
    customize: 'Pielāgot',
    accept_all: 'Pieņemt visus',
    deny_all: 'Noraidīt visus',
    save: 'Saglabāt preferences',
    title: 'Sīkfailu preferences',
    necessary: 'Nepieciešamie',
    necessary_desc: 'Būtiski svarīgi vietnes pareizai darbībai.',
    statistics: 'Statistika',
    statistics_desc: 'Palīdz saprast, kā apmeklētāji mijiedarbojas ar vietni.',
    marketing: 'Mārketings',
    marketing_desc: 'Izmanto atbilstošu reklāmu rādīšanai un kampaņu efektivitātes mērīšanai.',
    preferences: 'Preferences',
    preferences_desc: 'Atceras jūsu iestatījumus un personalizācijas izvēles.',
    always_on: 'Vienmēr aktīvi',
    read_more: 'Lasīt vairāk',
  },
  et: {
    banner_title: 'See veebisait kasutab küpsiseid',
    banner_message: 'Kasutame küpsiseid sisu ja reklaamide isikupärastamiseks, sotsiaalmeedia funktsioonide pakkumiseks ning liikluse analüüsimiseks. Samuti jagame teavet teie saidikasutuse kohta reklaami- ja analüüsipartneritega, kes võivad seda kombineerida muu teabega, mida olete neile andnud või mida nad on kogunud teiepoolse teenuste kasutamise käigus.',
    customize: 'Kohanda',
    accept_all: 'Nõustu kõigiga',
    deny_all: 'Keeldu kõigist',
    save: 'Salvesta eelistused',
    title: 'Küpsiste eelistused',
    necessary: 'Vajalikud',
    necessary_desc: 'Hädavajalikud veebisaidi nõuetekohaseks toimimiseks.',
    statistics: 'Statistika',
    statistics_desc: 'Aitavad meil mõista, kuidas külastajad veebisaiti kasutavad.',
    marketing: 'Turundus',
    marketing_desc: 'Kasutatakse asjakohaste reklaamide näitamiseks ja kampaaniate tõhususe mõõtmiseks.',
    preferences: 'Eelistused',
    preferences_desc: 'Jätavad meelde teie seaded ja isikupärastamise valikud.',
    always_on: 'Alati aktiivne',
    read_more: 'Lugege lisaks',
  },
};

function detectLang(pathname) {
  const path = pathname || (typeof window !== 'undefined' ? window.location.pathname : '/');
  for (const lang of SUPPORTED_LANGS) {
    if (path === `/${lang}` || path.startsWith(`/${lang}/`)) return lang;
  }
  return 'en';
}

function cookiesHref(lang) {
  return lang === 'en' ? '/cookies/' : `/${lang}/cookies/`;
}

function readConsent() {
  if (typeof document === 'undefined') return null;
  try {
    const match = document.cookie.match(/(?:^|; )chatlab_consent=([^;]*)/);
    if (match) return JSON.parse(decodeURIComponent(match[1]));
  } catch (e) { /* cookie parse error */ }
  return null;
}

function writeConsent(consent) {
  const data = { ...consent, timestamp: Date.now() };
  const value = encodeURIComponent(JSON.stringify(data));
  const expires = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString();
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const domain = isLocal ? '' : ';domain=.chatlab.com';
  document.cookie = `${COOKIE_NAME}=${value};expires=${expires};path=/${domain};SameSite=Lax`;
}

function pushConsentToGTM(consent) {
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  gtag('consent', 'update', {
    ad_storage: consent.marketing ? 'granted' : 'denied',
    ad_user_data: consent.marketing ? 'granted' : 'denied',
    ad_personalization: consent.marketing ? 'granted' : 'denied',
    analytics_storage: consent.statistics ? 'granted' : 'denied',
    functionality_storage: consent.preferences ? 'granted' : 'denied',
    personalization_storage: consent.preferences ? 'granted' : 'denied',
  });
  gtag('set', 'ads_data_redaction', !consent.marketing);
  if (consent.statistics) window.dataLayer.push({ event: 'cookie_consent_statistics' });
  if (consent.marketing) window.dataLayer.push({ event: 'cookie_consent_marketing' });
  if (consent.preferences) window.dataLayer.push({ event: 'cookie_consent_preferences' });
  window.dataLayer.push({ event: 'cookie_consent_update' });
}

function afterNextPaint(fn) {
  requestAnimationFrame(() => setTimeout(fn, 0));
}

const CATEGORIES = ['necessary', 'statistics', 'marketing', 'preferences'];

const CookieIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="8" cy="9" r="1.5" fill="currentColor"/>
    <circle cx="14.5" cy="7.5" r="1" fill="currentColor"/>
    <circle cx="16" cy="14" r="1.5" fill="currentColor"/>
    <circle cx="9.5" cy="15" r="1" fill="currentColor"/>
    <circle cx="12" cy="11.5" r="1" fill="currentColor"/>
  </svg>
);

const Toggle = ({ checked, disabled, onClick }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    onClick={onClick}
    disabled={disabled}
    className={`
      relative inline-flex h-6 w-11 shrink-0 rounded-full border-2 border-transparent
      transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2
      ${checked ? 'bg-[var(--cl-ink)]' : 'bg-[var(--cl-rule-strong)]'}
      ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
    `}
  >
    <span
      className={`
        pointer-events-none inline-block h-5 w-5 rounded-full bg-white
        ring-0 transition-transform duration-300
        ${checked ? 'translate-x-5' : 'translate-x-0'}
      `}
    />
  </button>
);

const CookieConsent = ({ pathname }) => {
  const [view, setView] = useState('banner');
  const [sliding, setSliding] = useState(true);
  const [consent, setConsent] = useState({
    necessary: true,
    statistics: false,
    marketing: false,
    preferences: false,
  });

  const lang = detectLang(pathname);
  const tx = TRANSLATIONS[lang] || TRANSLATIONS.en;

  useEffect(() => {
    const saved = readConsent();
    if (saved) {
      setConsent({ necessary: true, statistics: !!saved.statistics, marketing: !!saved.marketing, preferences: !!saved.preferences });
      setSliding(false);
      setView('icon');
    }
    document.documentElement.classList.remove(CONSENTED_CLASS);
  }, []);

  const dismiss = useCallback((newConsent) => {
    setConsent(newConsent);
    setSliding(false);
    setTimeout(() => setView('icon'), 400);
    // GTM handles dataLayer pushes synchronously and fires every consent-gated tag inside the
    // push, which made "Accept All" the slowest tap on the site (INP). The banner closes in this
    // frame; consent is stored and sent to GTM right after the next paint, same events, same order.
    afterNextPaint(() => {
      writeConsent(newConsent);
      pushConsentToGTM(newConsent);
    });
  }, []);

  const handleAcceptAll = useCallback(() => {
    dismiss({ necessary: true, statistics: true, marketing: true, preferences: true });
  }, [dismiss]);

  const handleDeny = useCallback(() => {
    dismiss({ necessary: true, statistics: false, marketing: false, preferences: false });
  }, [dismiss]);

  const handleSave = useCallback(() => {
    dismiss(consent);
  }, [dismiss, consent]);

  const openDetails = useCallback(() => {
    const saved = readConsent();
    if (saved) {
      setConsent({ necessary: true, statistics: !!saved.statistics, marketing: !!saved.marketing, preferences: !!saved.preferences });
    }
    setView('details');
    requestAnimationFrame(() => requestAnimationFrame(() => setSliding(true)));
  }, []);

  const toggle = useCallback((key) => {
    if (key === 'necessary') return;
    setConsent(prev => ({ ...prev, [key]: !prev[key] }));
  }, []);

  if (view === 'icon') {
    return (
      <button
        onClick={openDetails}
        aria-label={tx.title}
        className="fixed bottom-4 left-4 z-[9999] w-10 h-10 rounded-full border border-[var(--cl-rule)] bg-[var(--cl-surface)]/90 backdrop-blur-sm flex items-center justify-center text-[var(--cl-muted)] hover:text-[var(--cl-ink)] transition-colors duration-300 cursor-pointer"
      >
        <CookieIcon />
      </button>
    );
  }

  if (!view) return null;

  const isVisible = sliding;

  return (
    <>
      {isVisible && (
        <div data-cookie-consent="" className="fixed inset-0 z-[9998] bg-black/30" />
      )}

      <div
        role="dialog"
        aria-modal="true"
        aria-label={view === 'banner' ? tx.banner_title : tx.title}
        data-cookie-consent=""
        className={`fixed inset-0 z-[9999] flex items-center justify-center p-4 transition-opacity duration-400 ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
      >
        <div className="w-full max-w-xl bg-[var(--cl-surface)] rounded-[4px] border border-[var(--cl-rule)] overflow-hidden">

          {view === 'banner' && (
            <div className="p-7 sm:p-8">
              <h3 className="text-lg font-semibold text-[var(--cl-ink)] mb-3">
                {tx.banner_title}
              </h3>
              <p className="text-sm leading-relaxed text-[var(--cl-ink-2)] mb-6 text-justify">
                {tx.banner_message}
              </p>
              <div className="flex items-center gap-5">
                <button
                  onClick={() => setView('details')}
                  className="text-[13px] font-medium text-[var(--cl-ink-2)] hover:text-[var(--cl-ink)] underline-offset-4 hover:underline cursor-pointer"
                >
                  {tx.customize}
                </button>
                <button
                  onClick={handleAcceptAll}
                  className="ml-auto h-11 px-8 text-[13px] font-semibold text-white bg-[var(--cl-ink)] border-[1.5px] border-[var(--cl-ink)] rounded-full hover:bg-[var(--cl-ink-2)] transition-all duration-300 cursor-pointer"
                >
                  {tx.accept_all}
                </button>
              </div>
            </div>
          )}

          {view === 'details' && (
            <div className="p-7 sm:p-8">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-[var(--cl-ink)]">
                  {tx.title}
                </h3>
                <a
                  href={cookiesHref(lang)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-[var(--cl-muted)] hover:text-[var(--cl-ink)] transition-colors duration-200"
                >
                  {tx.read_more}
                </a>
              </div>

              <div className="mb-6">
                {CATEGORIES.map((key, i) => (
                  <div
                    key={key}
                    className={`flex items-center justify-between py-3 ${i < CATEGORIES.length - 1 ? 'border-b border-[var(--cl-rule)]' : ''}`}
                  >
                    <div className="flex-1 pr-3 min-w-0">
                      <div className="text-sm font-medium text-[var(--cl-ink)]">
                        {tx[key]}
                        {key === 'necessary' && (
                          <span className="text-[11px] text-[var(--cl-muted)] ml-2 font-normal">{tx.always_on}</span>
                        )}
                      </div>
                      <p className="text-xs text-[var(--cl-muted)] mt-0.5 leading-snug">
                        {tx[`${key}_desc`]}
                      </p>
                    </div>
                    <Toggle
                      checked={consent[key]}
                      disabled={key === 'necessary'}
                      onClick={() => toggle(key)}
                    />
                  </div>
                ))}
              </div>

              <div className="flex gap-2">
                <button
                  onClick={handleDeny}
                  className="flex-1 h-11 text-[13px] font-medium text-[var(--cl-muted)] bg-transparent border-[1.5px] border-[var(--cl-rule)] rounded-full hover:bg-[var(--cl-surface-2)] transition-all duration-300 cursor-pointer"
                >
                  {tx.deny_all}
                </button>
                <button
                  onClick={handleSave}
                  className="flex-1 h-11 text-[13px] font-medium text-[var(--cl-ink)] bg-transparent border-[1.5px] border-[var(--cl-rule)] rounded-full hover:bg-[var(--cl-surface-2)] transition-all duration-300 cursor-pointer"
                >
                  {tx.save}
                </button>
                <button
                  onClick={handleAcceptAll}
                  className="flex-1 h-11 text-[13px] font-semibold text-white bg-[var(--cl-ink)] border-[1.5px] border-[var(--cl-ink)] rounded-full hover:bg-[var(--cl-ink-2)] transition-all duration-300 cursor-pointer"
                >
                  {tx.accept_all}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CookieConsent;
